import axios from "axios";
import { apiClient, API } from "./apiClient";

export const createLead = (data) =>
  apiClient.post("/leads", data).then((r) => r.data);

export const getLeads = () => apiClient.get("/leads").then((r) => r.data);

// Multipart upload — plain axios so the browser sets the multipart boundary.
export const uploadPhotos = (files) => {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  return axios.post(`${API}/uploads`, fd).then((r) => r.data.files);
};
